import React, { useState } from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useAgent } from '../../store/agent.store'
import { AgentService } from '../../services/agent.service'
import { resetCustomerScopedState } from '../../utils/sessionReset'
import URLS from '../../enums/route'

/**
 * Pinned while an agent is inside a customer. Every write action on the app is
 * available to them, so which customer they are in has to be unmissable.
 */
const ImpersonationBanner = () => {
  const navigate = useNavigate()
  const { impersonating, setImpersonating } = useAgent()
  const [leaving, setLeaving] = useState(false)

  if (!impersonating) {
    return null
  }

  const leave = async () => {
    setLeaving(true)
    try {
      await AgentService.release()
    } catch (e) {
      // A failed release must still drop the local session, or the agent stays
      // stuck inside a customer because the network blipped.
      console.error('[AGENT RELEASE]', e)
    } finally {
      resetCustomerScopedState()
      setImpersonating(null)
      setLeaving(false)
      navigate(URLS.AGENT_CUSTOMERS.LINK)
    }
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        px: 2,
        py: 1,
        backgroundColor: '#8B1E1E',
        color: '#fff',
      }}
    >
      <Typography fontSize={14} fontWeight={600} noWrap>
        {`מחובר כלקוח: ${impersonating.name}`}
      </Typography>
      <Button size="small" variant="contained" color="inherit" disabled={leaving} onClick={leave}>
        {leaving ? '...' : 'יציאה'}
      </Button>
    </Box>
  )
}

export default ImpersonationBanner
